import React from 'react'
import * as yup from 'yup';
import TextField from '../../Reusable/Form/TextInput';
import Button from '../../Reusable/Button';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';

let reverseOrderValidationForm = yup.object().shape({
  refund_amount: yup.string().required("Refund Amount is required"),
});


const ReturnRTV = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError
  } = useForm<any>({
    resolver: yupResolver(reverseOrderValidationForm),
    defaultValues: async () => {
      return {
        charge: 0,
      }
    }
  })
  return (
    <div className='flex flex-col justify-between min-h-full'>
      <h1 className='text-sm text-gray-500'>Are you sure you want to return? It will create return order.</h1>
      <TextField
        label={"Refund Amount"}
        register={register("refund_amount")}
        errors={errors?.refund_amount}
      />
      <div className="w-[100px] mr-4 absolute bottom-4 right-2">
        <Button
          label={"Submit"}
          onClick={handleSubmit((data: any) =>
            props?.handleActionMenu(data, "RTV/Return", setError)
          )}
        />
      </div>
    </div>
  )
}

export default ReturnRTV
